import type { StepsRegistry, StepDefinition } from "./types";

export const stepsRegistry: Partial<StepsRegistry> = {};

/**
 * Registrar un paso en el registry
 */
export function registerStep(step: StepDefinition) {
  if (stepsRegistry[step.id]) {
    throw new Error(`El step "${step.id}" ya está registrado`);
  }
  stepsRegistry[step.id] = step;
}
